export const microformYearOptions = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() + i); // Next 10 years
